import { createElement as e } from "react";
import { Navbar, Nav, Glyphicon } from "react-bootstrap";
import Header from "../components/Header";
import NavItemLink from "sc/ui/components/NavItemLink";
import { Switch, Route } from "react-router";
import LoginPage from "sc/ui/sites/oncall/pages/LoginPage";

const Menu = () =>
  e(
    Navbar.Collapse,
    { className: "pull-right" },
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { eventKey: "1", href: "/" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-home" }),
        " Home",
      ),
    ),
  );

export default () =>
  e(
    "div",
    null,
    e(Header, { MenuComponent: Menu }),
    e(Switch, null, e(Route, { path: "*", component: LoginPage, exact: true })),
  );



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/routes/Anonymous.js